/**
 * 活动管理
 */
export default {}
